// Shared JWT payload decoder. JWT segments are base64url-encoded ("-"/"_"
// instead of "+"/"/", and often unpadded), which `atob` cannot decode directly,
// so we convert to standard base64 and repad first. Returns the parsed payload
// as `unknown` (narrow it with a Zod schema at the call site), or null when the
// token is malformed / cannot be decoded. Never throws.
export function decodeJwtPayload(token: string): unknown {
  try {
    const segment = token.split('.')[1]
    if (!segment) return null
    const base64 = segment.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=')
    return JSON.parse(atob(padded))
  } catch {
    return null
  }
}
